import { SENDER_TYPE } from '@backrs_ui/common-ui';

import {
  ResumeBuilderStep,
  SolutionSessionId,
  SolutionSessionMessage,
} from '@backrs_ui/grow-ui/src/models/models';

type Step = Readonly<{
  step: number;
  label: string;
  value: ResumeBuilderStep;
}>;

type StepRanges = Readonly<{
  previousAndCurrentSteps: Step[];
  nextSteps: Step[];
}>;

export const STEPS: Step[] = [
  {
    step: 1,
    label: 'Basic Information',
    value: 'basic_information',
  },
  {
    step: 2,
    label: 'Dig for Gold',
    value: 'digging_for_gold',
  },
  {
    step: 3,
    label: 'Polish',
    value: 'polish',
  },
];

const SECTIONS_WITHOUT_BASIC_INFORMATION: SolutionSessionId[] = ['resume_builder.skills'];

export const getCurrentStepForDisplay = (
  solutionSessionMessages: SolutionSessionMessage[],
  solutionSession: SolutionSessionId,
): ResumeBuilderStep => {
  const currentStep = getCurrentStep(solutionSessionMessages);
  const isSectionWithoutBasicInfo = SECTIONS_WITHOUT_BASIC_INFORMATION.includes(solutionSession);

  switch (currentStep) {
    case 'basic_information':
      return isSectionWithoutBasicInfo ? 'polish' : 'basic_information';
    case 'digging_for_gold':
      return isSectionWithoutBasicInfo ? 'digging_for_gold' : 'basic_information';
    case 'polish':
      return isSectionWithoutBasicInfo ? 'digging_for_gold' : 'digging_for_gold';
    default:
      return 'polish';
  }
};

export const getCurrentStep = (
  solutionSessionMessages: SolutionSessionMessage[],
): ResumeBuilderStep => {
  const lastAIMessage = solutionSessionMessages
    .slice() // slice to create deep copy of array
    .reverse()
    .find((message) => message.sender === SENDER_TYPE.AI);

  return lastAIMessage?.resume_builder_step as ResumeBuilderStep;
};

export const getStepRanges = (
  currentStepValue: ResumeBuilderStep | undefined,
  solutionSession: SolutionSessionId,
): StepRanges => {
  if (!currentStepValue) return { previousAndCurrentSteps: [], nextSteps: [] };

  const currentStepIndex = STEPS.findIndex((step) => step.value === currentStepValue);

  if (currentStepIndex === -1) return { previousAndCurrentSteps: [], nextSteps: [] };

  const previousAndCurrentSteps = STEPS.slice(0, currentStepIndex + 1);
  const nextSteps = STEPS.slice(currentStepIndex + 1);

  const filterSteps = (steps: Step[]) =>
    SECTIONS_WITHOUT_BASIC_INFORMATION.includes(solutionSession)
      ? steps.filter((step) => step.value !== 'basic_information')
      : steps;

  return {
    previousAndCurrentSteps: filterSteps(previousAndCurrentSteps),
    nextSteps: filterSteps(nextSteps),
  };
};
